import React,{useState,useEffect} from 'react';
import axios from 'axios';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import { useParams, useLocation } from 'react-router-dom';
import { Integer } from 'aws-sdk/clients/apigateway';
import MetaTag from "../../components/MetaTag/MetaTag";
interface YouTubeVideo {
    Id: Integer;
    Title: string;
    ThumbNailUrl: string;
    ThumbNailWidth: string;
    ThumbNailHeight: string;
    Video: string,
    ChannelId: string,
    Published: string,
    IsExternal: boolean,
    IsInternal: boolean,
    IsDelete: boolean,
    CreatedOn: string,
    UpdatedOn:string,
}


const VideoPlayerPage = () => {
    const [video, setVideos] = useState<YouTubeVideo[]>([]);
    const [loading, setLoading] = useState(true);
    const { videoId } = useParams();
    useEffect(() => {
        const fetchVideos = async () => {
        const youTubeConfigUrl = process.env.REACT_APP_YOUTUBEVIDEO_URL;
        try {            
            // Fetch videos from uploads playlist
            const videosRes = await axios.get(`${youTubeConfigUrl}`).then((data) => {
              if(data.data.statusCode == 200){
                const parseData = JSON.parse(data.data.body); 
                const videosData = JSON.parse(parseData.data);
                const filterData = videosData.filter((item:any) => item.ItemId === videoId);
                setVideos(filterData);
              }
            });            
        } catch (error) {
            console.error("Failed to fetch videos", error);
        } finally {
            setLoading(false);
        }
    };

    fetchVideos();
    }, []);
    return(
        <>
            <MetaTag title={"BCE Global Tech YouTube Videos"} description={""} />
            {loading ? (
                <>
                    <div id="brf-page-loader" className="loader-fixed bgWhite container-flex-box brf-page-loader">
                        <img src="../content/img/loader.gif" />
                        <div className="page-loader-msg middle-align-self pad-left-10">Loading data, please wait</div>
                    </div>
                </>
            ) : (
                <div className='container liquid-container pad-top-30 pad-bottom-30'>
                    <div className="clear spacer10"></div>
                    <VideoPlayer title={video[0].Title} 
                        description={""}
                        videoLink={video[0].Video} 
                        controls={true}
                        isExternal={true}/>
                </div>
        )}
        </>
    )
};

export default VideoPlayerPage;